module.exports = Object.freeze({
    NEEDS_UPDATE: 1,
    LINK_BROKEN: 2,
    CONTENT_INAPPROPRIATE: 3,
});